import { PERMISSIONS } from './permissions';
import { PERMISSION_ROLES } from './permissionRoles';

const { ACCOUNT_ADMINISTRATOR, ADVANCED_USER } = PERMISSION_ROLES;

/**
 * Mapping of each permission key to the list of user role codes that are allowed to have this permission.
 *
 * Each property key is a permission string (from {@link PERMISSIONS}), and its value is an array of
 * role codes (from {@link PERMISSION_ROLES}) that grant access to this permission.
 *
 * Use this map to check whether a given user's role provides access to a specific permission.
 *
 * @readonly
 * @type {Object.<string, number[]>}
 */
export const PERMISSIONS_MAP = {
    [PERMISSIONS.MANAGE_USERS]: [ACCOUNT_ADMINISTRATOR],
    [PERMISSIONS.MANAGE_MESHBOTS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_VARIABLES_EXPRESSIONS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_LUA_SCRIPTS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_CLOUD_SERVICES_INTEGRATIONS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_VIRTUAL_CONTAINER]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_BACKUPS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_CONTROLLER_SETTINGS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_DEVICE_SETTINGS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_PLUGINS]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
    [PERMISSIONS.MANAGE_NOTIFICATIONS_TEMPLATES]: [ACCOUNT_ADMINISTRATOR, ADVANCED_USER],
};
